<img
  #img
  [src]="src"
  [alt]="alt"
  [class]="mainImageClass"
  [ngClass]="{'blur':!loaded}"
  >

<img
  class="sn-img-dummy"
  [src]="bigImageSrc"
  (load)="onImagePreload()"
  (error)="onImagePreloadError()"
  [alt]="alt">